import React, { useState, useEffect } from 'react'
import Navbar2 from '../Components/Navbar2'
import Footer2 from '../Components/Footer2'
import Aos from 'aos'
import MediaSlider from '../Components/MediaSlider';
import { getOurMedia } from '../Common/apis';
import Loader from '../Loader/Loader';

function OurMedia() {
  const [mediaData, setMediaData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });
  }, []);

  useEffect(() => {
    const fetchMedia = async () => {
      setLoading(true);
      try {
        const response = await getOurMedia();
        if (response.data && response.data.length > 0) {
          setMediaData(response.data);
        } else {
          console.error('Failed to fetch media');
        }
      } catch (error) {
        console.error('Error fetching media:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, []);
  return (
    <>
      <div className="new-home">
        {loading && <Loader />}
        <Navbar2 />
        <div className="flex justify-between md:flex-row flex-col md:items-center items-start lg:pr-[147px] md:pr-[100px] pr-[20px]">
          <div>
            <div className='md:flex hidden flex-col pb-[24px] gap-[12px] ml-[-70px] items-start'>
              <img data-aos="flip-up" src="/assets/media/item2.svg" className='xl:h-auto lg:h-[88px] md:h-[53px] h-[53px]' alt="" />
              <img data-aos="flip-up" src="/assets/media/item1.svg" className='xl:h-auto lg:h-[88px] md:h-[53px] h-[53px]' alt="" />
            </div>
            <div className='flex md:hidden flex-col lg:pb-[45px] pb-[16px] gap-[8px] ml-[-65px] items-start'>
              <img data-aos="flip-up" src="/assets/media/mobile-item1.svg" className='h-[53px]' alt="" />
              <img data-aos="flip-up" src="/assets/media/mobile-item2.svg" className='h-[53px]' alt="" />
            </div>
          </div>
          <div className='pb-[30px]'>
            <img data-aos="flip-up" src="/assets/media/vector1.svg" alt="" />
          </div>
        </div>
        <div className='overflow-hidden'>
          <MediaSlider mediaItems={mediaData} />
        </div>
        <Footer2 />
      </div>
    </>
  )
}

export default OurMedia